var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRonspotSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M981.248 386.621C924.809 162.288 724.733 0 501.22 0C224.734 0 0 221.099 0 492.725V1000H192.949V492.725C192.949 326.597 331.294 191.188 501.22 191.188C636.102 191.188 759.163 293.856 794.211 432.7C815.197 516.572 810.099 604.488 780.149 674.011C756.313 729.383 718.821 767.785 680.519 788.805L549.915 660.266L655.66 555.578H310.919L309.289 902.588L413.608 795.875L617.358 998.587L627.75 999.193H630.397C774.242 999.193 903.621 874.092 957.412 749.391C1004.27 640.665 1012.83 511.924 981.248 386.621Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRonspotSquareLogo);
export default __webpack_public_path__ + "static/media/ronspot-square-logo.1307522aec7dea76886b7691bbb50765.svg";
export { ForwardRef as ReactComponent };